/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { ElectroButton } from 'components/ExtendedUiElements/customized.js';

import CentralForm from 'components/CentralForm/CentralForm.js';

import styles from 'common-scss/formstyles.module.scss';

type TypeComponent = Class<React.Component<*>>;

//PasswordUpdated.js
function PasswordUpdatedP({ t }: TranslatorProps): React.Element<*> {
  return this.props.location.state.success ? (
    <CentralForm>
      <h1>{t('general:success')}</h1>
      <p>
        {t('general:accounts.messages.successful_password_update')}
        <br />
        {t('general:accounts.messages.log_in')}
      </p>
      <Link to="/login" className={styles['button-anchor']}>
        <ElectroButton label={t('general:actions.sign_in')} color="primary" />
      </Link>
    </CentralForm>
  ) : (
    <CentralForm>
      <h1>{t('general:failed')}</h1>
      <p>
        {t('general:messages.request_failed')}
        <br />
        {this.props.location.state.data.message}
      </p>
      <Link to="/forgotten-password" className={styles['button-anchor']}>
        <ElectroButton label={t('general:actions.request')} color="primary" />
      </Link>
    </CentralForm>
  );
}

const PasswordUpdated: TypeComponent = translate()(observer(PasswordUpdatedP));

export default PasswordUpdated;
